<script>
import _ from "lodash";

export default {
  name: "DialogEditEduHours",
  props: {
    dialog_vis_edit_hours: {
      type: Boolean
    },
    semester_hours: {
      type: Array
    }
  },
  data: () => ({
    edit_semester_hours: []
  }),
  mounted() {

  },
  methods: {
    closeDialogEditEduHours() {
      this.$emit('closeDialogEditEduHours')
    },
    setHoursInTypeWork(hours_value, hour_load) {
      this.$emit('setHoursInTypeWork', {
        hours_value: hours_value,
        hour_load: hour_load
      })
    }
  },
}
</script>

<template>
  <v-dialog
      @click:outside="closeDialogEditEduHours()"
      content-class="rounded-xl"
      v-model="dialog_vis_edit_hours"
      width="600"
  >
    <v-card>
      <v-card-title>
        <v-row no-gutters>
          <v-col cols="12" class="d-flex justify-end">
            <v-btn
                icon
                @click="closeDialogEditEduHours()"
            >
              <v-icon size="20">
                fa-times
              </v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" class="d-flex justify-center text-h5">
            Редактирование часов обучения
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row v-for="(hour, index) in semester_hours" :key="index">
          <v-col cols="6">
            <v-subheader class="text-h5">{{ hour.load }}</v-subheader>
          </v-col>
          <v-col cols="6">
            <v-text-field
                label="Часы"
                :value="hour.value"
                @input="setHoursInTypeWork($event, hour.load)"
                suffix="акад. час."
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn
            class="mx-auto rounded-xl"
            color="teal"
            @click="closeDialogEditEduHours()"
            outlined
        >
          Сохранить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>

</style>